export const animateCounter = (
  element,
  target,
  duration = 1500,
  formatter = (value) => value.toLocaleString("pt-BR")
) => {
  if (!element) return;

  const startTime = performance.now();

  const update = (currentTime) => {
    const progress = Math.min(
      (currentTime - startTime) / duration,
      1
    );

    const easedProgress = 1 - Math.pow(1 - progress, 3);
    const currentValue = Math.floor(target * easedProgress);

    element.textContent = formatter(currentValue);

    if (progress < 1) {
      requestAnimationFrame(update);
    }
  };

  element.textContent = formatter(0);
  requestAnimationFrame(update);
};